import { forwardRef } from 'react';

interface RoadConditionIconProps extends React.SVGProps<SVGSVGElement> {
  size?: 'small' | 'medium' | 'large';
}

const ICON_SIZES = {
  small: 20,
  medium: 24,
  large: 32,
};

const RoadConditionIcon = forwardRef<SVGSVGElement, RoadConditionIconProps>(
  ({ size = 'medium', ...props }, ref) => {
    const iconSize = ICON_SIZES[size];

    return (
      <svg
        width={iconSize}
        height={iconSize}
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        ref={ref}
        {...props}
      >
        <path d='M17.5 21H15.5V15.5H17.5V21Z' />
        <path d='M3.5 21H1.5V5H3.5V21Z' />
        <path d='M10.5 21H8.5V17H10.5V21Z' />
        <path d='M10.5 15H8.5V11H10.5V15Z' />
        <path d='M10.5 9H8.5V5H10.5V9Z' />
        <path d='M19.96 5.51C19.725 4.09 18.485 3 17 3C15.91 3 14.915 3.59 14.39 4.53C13.045 4.705 12 5.87 12 7.25C12 8.765 13.235 10 14.75 10H19.75C20.99 10 22 8.99 22 7.75C22 6.58 21.105 5.615 19.96 5.51ZM19.75 9H14.75C13.785 9 13 8.215 13 7.25C13 6.38 13.655 5.635 14.52 5.52L15.015 5.455L15.26 5.02C15.615 4.39 16.28 4 17 4C17.97 4 18.815 4.72 18.975 5.675L19.1 6.435L19.87 6.505C20.505 6.565 21 7.11 21 7.75C21 8.44 20.44 9 19.75 9Z' />
        <path d='M18.4 10.5L16.95 12.16L17.95 12.66L16.775 14H18.1L19.55 12.34L18.55 11.84L19.725 10.5H18.4Z' />
        <path d='M15.4 10.5L13.95 12.16L14.95 12.66L13.775 14H15.1L16.55 12.34L15.55 11.84L16.725 10.5H15.4Z' />
      </svg>
    );
  }
);

export default RoadConditionIcon;
